import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    QuestionnaireChoiceColorsConstantType,
    QuestionnaireChoiceDynamicStyleType,
    QuestionnaireChoiceColors
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getSelectionControlCardStyle
} from "../../../selectionControl/stylesheet";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

export const getQuestionnaireChoiceColors = ({
    isDisabled,
    colors
}: QuestionnaireChoiceColorsConstantType): QuestionnaireChoiceColors => {
    if(isDisabled) {
        return {
            subTitleColor: colors.content.text.disabled,
            titleColor: colors.content.text.disabled
        };
    }

    return {
        subTitleColor: colors.content.text.mid,
        titleColor: colors.content.text.high
    };
};

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "flex-start",
        flexDirection: "row",
        ...webStyle({
            outlineStyle: "solid",
            userSelect: "none",
            outlineWidth: 0
        })
    },
    indicator: {
        justifyContent: "center",
        pointerEvents: "none",
        alignItems: "center",
        flexShrink: 0
    },
    shortcut: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    },
    label: {
        flexDirection: "column",
        flexShrink: 1,
        flexGrow: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    currentMeasures,
    isFocusVisible,
    shapeConfigs,
    isDisabled,
    iconSizes,
    isChecked,
    radiuses,
    borders,
    isError,
    colors,
    spaces
}: QuestionnaireChoiceDynamicStyleType) => {
    const styles = {
        indicator: {
            marginTop: (currentMeasures.lineHeight - iconSizes.small) / 2,
            height: iconSizes.small,
            width: iconSizes.small
        } as Mutable<ViewStyle>,
        container: {
            ...getSelectionControlCardStyle({
                isDisabled,
                isChecked,
                radiuses,
                borders,
                isError,
                colors,
                spaces
            }),
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            minHeight: currentMeasures.rowHeight,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        shortcut: {
            height: currentMeasures.lineHeight
        } as Mutable<ViewStyle>
    };

    if(isDisabled) {
        styles.container.backgroundColor = "transparent";
    }

    Object.assign(styles.container, webStyle({
        cursor: isDisabled ? "not-allowed" : "pointer"
    }));

    Object.assign(styles.container, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
